module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_tablet_04@2x-411f3e4b3e466196f3cbb3f44284b742.jpg";